<script>
	import listBase from '@_system/components/base/list.vue'
	import deliverytool from '@/tool/deliverytool/index.vue'
	export default {
		extends: listBase,
		name: 'exchangetask',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				this.deliverytool?<deliverytool data={this.currentdata} action={this.currentaction} ref="deliverytool" onHide={this.deliverytoolHide} />:'',
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'exchangetask',
				windowName: '售后任务',
				windowType: 'modal',
				deliverytool:false,
				currentaction:'',
				currentrow:[],
				currentdata:[],
				// pagerConfig: {
				// 	enabled: true,
				// 	autoHidden: false,
				// 	border: true,
				// 	size: 'mini',
				// 	perfect: false,
				// 	currentPage: 1,
				// 	pageSize: 20,
				// 	pageSizes: [10, 20, 50, 100, 200, 500],
				// },
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			reset(row){
				this.loading = true
				this.$api.exchangetask.reset({
					id:row.id
				}).then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
			},
			pull(){
				this.loading = true
				this.$api.exchangetask.pull().then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
					this.customreload()
				})
			},
			deliverytoolHide(){
				this.currentdata = []
				this.currentaction = ''
				this.deliverytool = false
			},
			deliverytoolShow(){
				let data = this.getGrid().getCheckboxRecords()
				data = data.filter((item)=>{
					return item.enable == 6
				})
				if( data.length!=0){
					this.currentdata = data.map((item)=>{
						return item.expresscode
					})
					this.currentaction = "拦截"			
					this.deliverytool = true
				}else{
					this.$message.error('请选择数据')
				}
			},
			updateSHForWorkbench(){
				this.loading = true
				this.$api.exchangetask.updateSHForWorkbench().then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
			},
			issend(){
				let data = this.getGrid().getCheckboxRecords()
				if( data.length!=0){
					let taskids = data.map((item)=>{
						return item.taskid
					})
					this.loading = true
					this.$api.exchangetask.updateenable({
						taskids:taskids,
						enable:5
					}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				}else{
					this.$message.error('请选择数据')
				}
			},
			unsend(){
				let data = this.getGrid().getCheckboxRecords()
				if( data.length!=0){
					let taskids = data.map((item)=>{
						return item.taskid
					})
					this.loading = true
					this.$api.exchangetask.updateenable({
						taskids:taskids,
						enable:6
					}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				}else{
					this.$message.error('请选择数据')
				}
			},
			createexchangeorder(row){
				this.loading = true
				this.$api.exchangetask.checkSh({
					expresscode:row.expresscode
				}).then(()=>{
					this.$message.success('暂无售后，正在打开表单....')
					this.loading = false
					this.formModule = {
						name: 'exchangeorder',
						id: 0,
						controlltype: 1,
						windowName: '新建售后单',
						foreingKey: {},
						extra: {
							ordercode:row.ordercode,
							reasonid:10095,
							autoapply:6,
							type:2
						}
					}
					this.formwindowShow = true
				},()=>{
					this.loading = false
				})

				// this.$api.flow.getSingleFlowTemplate(20).then((e) => {
				// 	if (e) {
				// 		let res = this.$router.resolve({
				// 			name: 'add',
				// 			query: {
				// 				name: 'paymentapplication',								
				// 				id: 0,
				// 				controlltype: 1,
				// 				windowName: '售后付款申请',
				// 				extra: JSON.stringify({
				// 					billCode: row.exchange_no,
				// 					componentname:'exchangepaymentform',
				// 					// receiveaccount:row.receive_account,
				// 				}),
				// 				isflow: 1,
				// 				flowid: 20
				// 			}
				// 		})
				// 		if (this.device != 'pc') {
				// 			this.$router.push(res.href.replace(/#/g, ''))
				// 		} else {
				// 			let win = window.open(res.href, this.moduleName + "add",
				// 				this.$store.state.system.windowConfig)
				// 			win.onload = () => {
				// 				console.log(this.moduleName + 'form open')
				// 			}
				// 		}
							
				// 	}
				// })
			},
			// list(page,updateForm,other) {				
			// 	return new Promise((resolve,reject) => {
			// 		this.$api[this.moduleName].list({
			// 			...page,
			// 			...updateForm,
			// 			...other,
			// 			...this.foreingKey,
			// 		}).then(() => {
			// 			resolve([])
			// 		}, () => {
			// 			reject()
			// 		})
			// 	})
			// },
			initList() {
				this.initOption()
			},
			getColumns() {
				return [{
						type: 'checkbox',
						title: '#',
						width:50
					},
					{
						field: 'shopname',
						title: '店铺'
					},
					{
						field: 'storage_name',
						title: '仓库'
					},
					{
						field: 'ordercode',
						title: '订单编号'
					},
					{
						field: 'expresscode',
						title: '物流单号'
					},
					{
						field: 'reasonName',
						title: '发起原因',
					},		
					{
						field: 'verifyStatusDesc',
						title: '快递核实状态',
					},
					{
						field: 'slaTime',
						title: '超时时间',
						slots: {
							default: ({row}) => {
								return this.getRemainingTime(row.slaTime)
							}
						}
					},
					{
						field: 'exchangecode',
						title: '万里牛售后单',
						slots: {
								default: ({
									row,
									column
								}) => {
									return <div>
										<i style ="margin-right:6px;cursor: pointer;font-size:14px;color:#409EFF" onClick = {() => {this.copycontent(column, row)}} class="el-icon-document-copy"></i> 
										<span> {row[column.field]} </span> 
									</div>
								},
								header: ({
									column
								}) => {
									return <div>
										<i style ="margin-right:6px;cursor: pointer;font-size:14px;color:#409EFF" onClick = {()=>{this.copycontent(column, null)}} class="el-icon-document-copy"></i> 
										<span>{column.title}</span> 
									</div>
								}
							}
						
					},
					
					{
						field: 'resendordercode',
						title: '补发销售单号',
					},
					
					{
						field: 'exchangeexpresscode',
						title: '补发快递单号',
					},
					{
						field: 'companyName',
						title: '补发快递公司',
					},	
					{
						field: 'status',
						title: '当前状态',
					},	
					{
						field: 'enable',						
						title: '确认已发送拦截信息',
						slots: {
							default: ({row}) => {
								return row.enable == 5?'是':'否'
							}
						}
					},	
					{
						field: 'error',						
						title: '错误',
						fixed: "right",
					},									
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.reset(row)}}>重置</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.createexchangeorder(row)}}>创建售后单</el-button>
								]
							}
						}
					}
				]
			},
			getForm() {
				return {
					//enabled:false,
					titleWidth: '80',
					titleAlign: 'center',
					items: [{
						field: 'exchange_no',
						title: '单据编号',
						itemRender: {
							name: '$input'
						}
					}, {
						itemRender: {
							name: '$buttons',
							children: [{
								props: {
									type: 'submit',
									content: '查询',
									status: 'primary'
								}
							}, {
								props: {
									type: 'reset',
									content: '重置'
								}
							}]
						}
					}],
					span: 4
				}
			},
			beforeCreateGrid(formConfig, columns, gridOptions) {
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '拦截',
						status: 'danger',
						code: 'deliverytoolShow'
					},{
						name: '拉取任务',
						status: 'primary',
						code: 'pull'
					},{
						name: '获取售后单',
						status: 'warning',
						code: 'updateSHForWorkbench'
					},{
						name: '发送状态',
						status: '',
						dropdowns: [{
							name:"是",
							code:'issend'
						},{
							name:"否",
							code:'unsend'
						}]
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					tools: this.tools
				}
			},
			toolbarButtonClickEvent(e) {
				this[e.code]()
			},
			tradedetail(row){
				this.loading = true
				this.$api.pendingexchange.getTradeDetail({
					tp_tid:row.tp_tid,
					tradeUids:row.salercpt_uid,
					shopUid:row.sys_shop,
				}).then((res)=>{
					this.loading = false
					if(res){
						this.$alert('买家付款：'+ this.$Lodash.sumBy(res, item=>parseFloat(item.tp_payment)))
						//tp_payment
					}else{
						this.$message.error('未查询到订单')
					}
				},()=>{
					this.loading = false
				})
				
			},
			getRemainingTime(timestamp) {
				const targetTime = timestamp * 1000; // 如果给定的是秒级时间戳，转为毫秒
				const currentTime = Date.now();
				const diff = targetTime - currentTime; // 剩余毫秒数
			
				if (diff <= 0) {
					return '已过期';
				}
				const seconds = Math.floor(diff / 1000);
				const hours = Math.floor(seconds / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);
				const remainingSeconds = seconds % 60;
				return `剩${hours}小时${minutes}分钟${remainingSeconds}秒`;
			}
			// add(){
			// 	alert(123)
			// },
		},
		components: {

		}
	}
</script>